// App Improvements API. Thin wrappers so the pages read as intent.
import { apiDelete, apiGetAll, apiGet, apiPatch, apiPost } from "../../api";

export const CATEGORIES = [
  { value: "BUG", label: "Bug", hint: "Something isn't working", color: "#b91c1c", bg: "#fee2e2" },
  { value: "IMPROVEMENT", label: "Improvement", hint: "Works, but could be better", color: "#1d4ed8", bg: "#dbeafe" },
  { value: "FEATURE", label: "New feature", hint: "Something you'd like added", color: "#6d28d9", bg: "#ede9fe" },
];

export const PRIORITIES = [
  { value: "LOW", label: "Low", color: "#6b7280" },
  { value: "MEDIUM", label: "Medium", color: "#d97706" },
  { value: "HIGH", label: "High", color: "#dc2626" },
];

export const STATUSES = [
  { value: "SUBMITTED", label: "Submitted", color: "#6b7280" },
  { value: "REVIEWING", label: "Reviewing", color: "#0891b2" },
  { value: "IN_PROGRESS", label: "In progress", color: "#d97706" },
  { value: "READY_FOR_REVIEW", label: "Ready for review", color: "#7c3aed" },
  { value: "RESOLVED", label: "Resolved", color: "#16a34a" },
];

export const lookup = (list, value) => list.find((o) => o.value === value) || list[0];

export const screenshotUrl = (id) => `/api/feedback/screenshots/${id}/`;

export const listFeedback = () => apiGetAll("/feedback/");
export const getFeedback = (id) => apiGet(`/feedback/${id}/`);
export const createFeedback = (body) => apiPost("/feedback/", body);
export const updateFeedback = (id, body) => apiPatch(`/feedback/${id}/`, body);
export const deleteFeedback = (id) => apiDelete(`/feedback/${id}/`);
export const addFeedbackComment = (id, body) =>
  apiPost(`/feedback/${id}/comments/`, { body });
export const addFeedbackScreenshot = (id, image, kind) =>
  apiPost(`/feedback/${id}/screenshots/`, { image, kind });
export const approveFeedback = (id, body = "") =>
  apiPost(`/feedback/${id}/approve/`, { body });
export const requestFeedbackChange = (id, body) =>
  apiPost(`/feedback/${id}/request_change/`, { body });
